import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

const fetchPortal = async (
	portalShortName: string,
): Promise<{
	portalId: string;
	stationName: string;
	postalCode: string;
	locality: string;
}> => {
	const response = await apiDal.post("/portals/shortname", {
		portalShortName,
	});

	return response.data;
};

export const useGetPortal = (portalShortName: string) => {
	return useQuery<{
		portalId: string;
		stationName: string;
		postalCode: string;
		locality: string;
	}>({
		queryKey: ["useGetPortal", portalShortName],
		queryFn: () => fetchPortal(portalShortName),
		enabled: !!portalShortName,
	});
};
